import PropTypes from 'prop-types';
import { AiAssistantProgressSteps } from '../../components/index.js';
import {
  AI_TASK_TYPES,
  AI_WORKFLOW_PHASES,
  isGuidedAiTask,
} from '../utilities/aiAssistantState.js';

const BASE_STEPS = [
  { key: 'describe', label: 'Describe', iconClass: 'bi-chat-left-text' },
  { key: 'working', label: 'Working', iconClass: 'bi-stars' },
  { key: 'review', label: 'Review', iconClass: 'bi-eye' },
  { key: 'done', label: 'Done', iconClass: 'bi-check2-circle' },
];

const phaseStep = (run) => {
  if (run.phase === AI_WORKFLOW_PHASES.CONFIRM) return 'confirm';
  if (run.phase === AI_WORKFLOW_PHASES.REFINE) return 'review';
  if (run.phase === AI_WORKFLOW_PHASES.ERROR) {
    return run.previewId ? 'review' : 'working';
  }
  return run.phase;
};

export const AiAssistantSteps = ({ run }) => {
  if (!run || !isGuidedAiTask(run.task?.type)) return null;

  const steps = run.task.type === AI_TASK_TYPES.REGENERATE_PAGE
    ? [
      BASE_STEPS[0],
      { key: 'confirm', label: 'Confirm', iconClass: 'bi-shield-check' },
      ...BASE_STEPS.slice(1),
    ]
    : BASE_STEPS;
  const currentStep = phaseStep(run);
  return (
    <AiAssistantProgressSteps
      steps={steps}
      currentStep={currentStep}
      ariaLabel="AI editing progress"
    />
  );
};

AiAssistantSteps.propTypes = {
  run: PropTypes.object,
};
